import axios from "axios";
import { WebAPI, IFailCallbackParam, ISelectProjectParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでプロジェクト削除が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosDelete(url: string, token?: string) {
  if (token) {
    return axios.delete(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.delete(url);
  }
}

export interface IDeleteProjectsParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * 選択プロジェクトパラメータ配列
   */
  projects: ISelectProjectParam[];
}

/**
 * プロジェクトを削除します
 * @function deleteProjects
 * @param {IDeleteProjectsParams} params - プロジェクト削除パラメータ
 */
export function deleteProjects(params: IDeleteProjectsParams): void {
  const { authService, projects } = params;
  if (authService) {
    const promises = projects.map((project) => {
      const { projectid, etag } = project;
      const url = WebAPI.DELETE_PROJECT(projectid, etag);
      return new Promise((resolve, reject) => {
        authService.getToken({
          success: (token) => {
            AxiosDelete(url, token)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          },
          fail: (err) => {
            reject(err);
          },
        });
      });
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        if (status === 401) {
          deleteProjectsRetry401(authService, projects, params);
        } else {
          params.fail(id, status);
        }
      });
  } else {
    const promises = projects.map((project) => {
      const { projectid, etag } = project;
      return AxiosDelete(WebAPI.DELETE_PROJECT(projectid, etag));
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      });
  }
}

/**
 * プロジェクトを削除します
 * @function deleteProjectsRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {ISelectProjectParam[]} projects - 選択プロジェクトパラメータ配列
 * @param {ICallbackParams} params - コールバックパラメータ
 */
export function deleteProjectsRetry401(
  authService: AuthService,
  projects: ISelectProjectParam[],
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      const promises = projects.map((project) => {
        const { projectid, etag } = project;
        const url = WebAPI.DELETE_PROJECT(projectid, etag);
        return new Promise((resolve, reject) => {
          AxiosDelete(url, token)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promises)
        .then(() => {
          params.success(200);
        })
        .catch((err) => {
          const { id, status } = getErrorStatus(err);
          params.fail(id, status);
        });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
